import type { Store } from 'redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

import {
  connectorAbortGenerator,
  connectorRequestGenerator,
} from 'redpoints-front-common-rp10/middlewares';

import reducers from '../reducers';
import {
  APPLICATION_SUITE,
  APPLICATION_TOKEN,
  ENVIRONMENT,
  SCHEME,
} from '../config/constants';

const configureStore = (): { store: Store } => {
  const initialState = {};
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
  const middlewareEnhancer = applyMiddleware(
    thunk,
    connectorAbortGenerator,
    connectorRequestGenerator({
      APPLICATION_SUITE,
      APPLICATION_TOKEN,
      ENVIRONMENT,
      SCHEME,
    })
  );
  const composedEnhancers =
    typeof devToolsExtension === 'function'
      ? compose(middlewareEnhancer, devToolsExtension({ name: '- PORTAL -' }))
      : middlewareEnhancer;

  const store = createStore(reducers, initialState, composedEnhancers);

  return { store };
};

export default configureStore;
